import algosdk, {Transaction, encodeUnsignedTransaction} from "algosdk";
import {SignerTransaction} from "@tinymanorg/tinyman-js-sdk";

import {SignerEncodedTransaction} from "../../widgetTypes";

function filterSignerTransactionsWithAddress(
  txns: SignerTransaction[][],
  address: null | string
) {
  return txns.map((txGroup) =>
    txGroup.filter(
      (txDetail) => !txDetail.signers || !address || txDetail.signers.includes(address)
    )
  );
}

function encodeUnsignedTransactionInBase64(txn: Transaction): string {
  return Buffer.from(algosdk.encodeUnsignedTransaction(txn)).toString("base64");
}

/**
 * Encodes the `txn` field of the `SignerTransaction` in base64.
 */
function encodeTxnsInTxGroups(
  txGroups: SignerTransaction[][]
): SignerEncodedTransaction[][] {
  return txGroups.map((txGroup) =>
    txGroup.map<SignerEncodedTransaction>((txn) => ({
      txn: encodeUnsignedTransaction(txn.txn),
      signers: txn.signers
    }))
  );
}

export {
  filterSignerTransactionsWithAddress,
  encodeTxnsInTxGroups,
  encodeUnsignedTransactionInBase64
};
